module.exports = __webpack_public_path__ + "img/game-uphold.ea8a6b9.webp";